import { render, staticRenderFns } from "./stock_inventory.vue?vue&type=template&id=0668e1d5&scoped=true&"
import script from "./stock_inventory.vue?vue&type=script&lang=js&"
export * from "./stock_inventory.vue?vue&type=script&lang=js&"
import style0 from "./stock_inventory.vue?vue&type=style&index=0&id=0668e1d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0668e1d5",
  null
  
)

export default component.exports